/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { VisitIdsDtoModel, VisitIdsDtoModelType } from "./VisitIdsDtoModel"
import { VisitIdsDtoModelSelector } from "./VisitIdsDtoModel.base"
import { RootStoreType } from "./index"


/**
 * ProjectUnscheduledStopsBulkUpdatedDtoBase
 * auto generated base class for the model ProjectUnscheduledStopsBulkUpdatedDtoModel.
 *
 * Unscheduled stops bulk edited
 */
export const ProjectUnscheduledStopsBulkUpdatedDtoModelBase = ModelBase
  .named('ProjectUnscheduledStopsBulkUpdatedDto')
  .props({
    __typename: types.optional(types.literal("ProjectUnscheduledStopsBulkUpdatedDto"), "ProjectUnscheduledStopsBulkUpdatedDto"),
    projectId: types.union(types.undefined, types.string),
    updatedVisitIds: types.union(types.undefined, types.array(types.late((): any => VisitIdsDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ProjectUnscheduledStopsBulkUpdatedDtoModelSelector extends QueryBuilder {
  get projectId() { return this.__attr(`projectId`) }
  updatedVisitIds(builder: string | VisitIdsDtoModelSelector | ((selector: VisitIdsDtoModelSelector) => VisitIdsDtoModelSelector) | undefined) { return this.__child(`updatedVisitIds`, VisitIdsDtoModelSelector, builder) }
}
export function selectFromProjectUnscheduledStopsBulkUpdatedDto() {
  return new ProjectUnscheduledStopsBulkUpdatedDtoModelSelector()
}

export const projectUnscheduledStopsBulkUpdatedDtoModelPrimitives = selectFromProjectUnscheduledStopsBulkUpdatedDto().projectId
